import React from 'react';
import './Proofer.css';
import SideBar from './SideBar/SideBar';
import { Outlet } from 'react-router-dom';

export default function Proofer(props) {
    return (
        <div className="proofer">
            <SideBar />
            <Outlet />
        </div>
    );
}